import React from 'react';
import { Card, CardActionArea, CardContent, Typography, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface NewCardProps {
  width: number;
  height: number;
  label: string;
  onClick: () => void;
}

export function NewCard(props: NewCardProps) {
  const { width, height } = props;

  return (
    <Card
      square
      elevation={0}
      sx={{ width, height, borderStyle: 'dashed', borderColor: '#00000020', backgroundColor: 'background.default' }}
    >
      <CardActionArea sx={{ height: '100%' }} onClick={props.onClick}>
        <CardContent sx={{ textAlign: 'center' }}>
          <AddIcon fontSize="large" />
          <Typography variant="h5">{props.label}</Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
